module.exports = __webpack_public_path__ + "img/logo8.5e301467.jpg";